import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { tracker } from 'utils/tracker';
import { nanoid } from 'nanoid';
const PUBLIC_KEY = '0x4AAAAAABIL7W3Z3Gb8qWoC';
export const CaptchaVerification = ({ btcAddress, onVerified, onError, }) => {
    const [isCaptchaOpen, setIsCaptchaOpen] = useState(false);
    const captchaRef = useRef(null);
    const [isVerified, setIsVerified] = useState(false);
    const verifyCaptcha = useCallback(() => {
        const storedToken = tracker.getCaptchaToken();
        if (storedToken) {
            if (!tracker.isIdempotencyKeyValid()) {
                tracker.setIdempotencyKey(nanoid());
            }
            setIsVerified(true);
            onVerified?.();
            return;
        }
        if (!btcAddress) {
            return;
        }
        setIsCaptchaOpen(true);
        setTimeout(() => {
            try {
                if (window.turnstile && captchaRef.current) {
                    window.turnstile.render(captchaRef.current, {
                        sitekey: PUBLIC_KEY,
                        callback: token => {
                            tracker.setCaptchaToken(token);
                            tracker.setIdempotencyKey(nanoid());
                            setIsCaptchaOpen(false);
                            setIsVerified(true);
                            onVerified?.();
                        },
                        'error-callback': () => {
                            setIsCaptchaOpen(false);
                        },
                        'expired-callback': () => {
                            setIsCaptchaOpen(false);
                        },
                    });
                }
                else {
                    console.error('Turnstile not available');
                    setIsCaptchaOpen(false);
                }
            }
            catch (e) {
                console.error('Error rendering CAPTCHA:', e);
                setIsCaptchaOpen(false);
                onError?.();
            }
        }, 300);
    }, [btcAddress, onError, onVerified]);
    // Trigger CAPTCHA verification when BTC address is available and not yet verified
    useEffect(() => {
        if (btcAddress && !isVerified && !tracker.getCaptchaToken()) {
            verifyCaptcha();
        }
    }, [btcAddress, isVerified, verifyCaptcha]);
    if (!btcAddress || isVerified || !isCaptchaOpen) {
        return null;
    }
    return (_jsx("div", { className: classNames('fixed -inset-px flex justify-center items-center z-10 bg-black bg-opacity-50', !isCaptchaOpen && 'hidden'), children: _jsx("div", { className: "bg-black rounded-lg p-4 w-[300px] h-[70px] flex flex-col justify-center items-center", children: _jsx("div", { id: "turnstile-captcha", ref: captchaRef }) }) }));
};
